<template>
  <card-component title="Horario" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" :header-search-input="false">
    <div slot="headerRight" class="card-header-icon buttons">
      <b-button type="is-link" icon-left="content-copy" @click="copyWeek" v-if="!hasCopyTask">
        Copiar
      </b-button>
      <b-button type="is-success" icon-left="content-paste" @click="pasteTasksWeek" :disabled="invalidWeekToPaste" v-else>
        Pegar
      </b-button>

      <b-button type="is-link" class="is-pulled-right" @click="isICAModalActive = true" :loading="isDownloadingICA">
        Informe ICA
      </b-button>
      <b-button type="is-link" class="is-pulled-right" @click="isDownloadModalActive = true" :loading="isDownloading">
        Calendario
      </b-button>
    </div>
    <div class="table-container"  slot="content">
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      <table class="table is-bordered is-fullwidth">
        <thead>
          <tr>
            <th class="prd-col">Horario</th>
            <th :class="['dly-tsk-col', {'block-day':day.events.length > 0 }]" v-for="(day, index) in days" :key="`day-${index}`">{{day.name}}<br>{{day.date}}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="userId && !isLoading && dailyWork.length > 0">
            <tr v-for="(period, index) in periods" :key="`period-${index}`" :class="{'break-time': index == 4}">
              <td class="prd-item">
                <p class="prd-title">Periodo {{index+1}}</p>
                <p class="prd-time">{{$moment(period.start, 'hh:mm:ss').format('hh:mm')}} - {{$moment(period.finish, 'hh:mm:ss').format('hh:mm')}}</p>
              </td>
              <template v-for="(workOfDay, dailyWorkIndex) in dailyWork">
                <template v-if="days[dailyWorkIndex].events.length === 0">
                  <period-weekly-calendar
                    :period="period"
                    :activity="workOfDay.periods[index]"
                    :day="workOfDay.day"
                    :key="`day-${dailyWorkIndex}-period-${index}`"
                    @clicked-period="periodSelected"
                    @clear-period="getTaskUsers">
                  </period-weekly-calendar>
                </template>
                <template v-else>
                  <td :key="`day-${dailyWorkIndex}-period-${index}`" class="perdiod-block">
                  </td>
                </template>
              </template>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="7" class="prd-item">
                <div class="columns is-centered is-vcentered" style="height:200px;">
                  <div class="column is-6">
                    <p><b>Seleccione un Jinete</b></p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <b-modal :active.sync="isDownloadModalActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
              <p class="modal-card-title">Descarga Calendario de Trabajo</p>
          </header>
          <section class="modal-card-body">
            <h3 class="title is-5">
              Elija una opción de descarga
            </h3>
            <div class="buttons">
              <b-button :disabled="!userId" type="is-info" @click="exporToPDF(true)" expanded>Solo Información Jinete</b-button>
          </div>
          <div class="buttons">
              <b-button type="is-info" @click="exporToPDF(false)" expanded>Información de todos los Jinetes</b-button>
          </div>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </b-modal>
      <ica-modal :active.sync="isICAModalActive"/>
      <b-modal
        :active.sync="isComponentModalActive"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal class="has-overflow">
          <work-form
            :period="selectedPeriod"
            :activity="selectedActivity"
            :day="selectedDay"
            :user-id="userId"
            @saved="getTaskUsers"
          ></work-form>
      </b-modal>
    </div>
  </card-component>
</template>

<script>
import TaskUserService from '@/services/TaskUserService'
import OffDayService from '@/services/OffDayService'

import PeriodWeeklyCalendar from './PeriodWeeklyCalendar'
import CardComponent from '@/components/CardComponent'
import CopyWeeklyService from '@/services/CopyWeeklyService'

import { SnackbarProgrammatic as Snackbar } from 'buefy'

import ICAModal from './ICAModal'
import WorkForm from './WorkForm'
export default {
  props: {
    startWeekDay: {
      type: Date,
      default: () => new Date()
    },
    finishWeekDay: {
      type: Date,
      default: () => new Date()
    },
    userId: {
      type: Number,
      default: null
    }
  },
  components: {
    WorkForm,
    CardComponent,
    PeriodWeeklyCalendar,
    'ica-modal': ICAModal
  },
  async created () {
    await this.generateDays()
    this.checkCopyWeek()
  },
  data () {
    return {
      isICAModalActive: false,
      isDownloadModalActive: false,
      isDownloading: false,
      isDownloadingICA: false,
      days: [],
      isLoading: false,
      isComponentModalActive: false,
      periods: [
        { order: 0, start: '08:30:00', finish: '09:30:00' },
        { order: 1, start: '09:30:00', finish: '10:30:00' },
        { order: 2, start: '10:30:00', finish: '11:30:00' },
        { order: 3, start: '11:30:00', finish: '12:30:00' },
        { order: 4, start: '12:30:00', finish: '13:30:00' },
        { order: 5, start: '13:30:00', finish: '14:30:00' },
        { order: 6, start: '14:30:00', finish: '15:30:00' },
        { order: 7, start: '15:30:00', finish: '16:30:00' },
        { order: 8, start: '16:30:00', finish: '17:30:00' },
        { order: 9, start: '17:30:00', finish: '18:30:00' },
        { order: 10, start: '18:30:00', finish: '19:30:00' },
        { order: 11, start: '19:30:00', finish: '20:30:00' },
        { order: 12, start: '20:30:00', finish: '21:30:00' },
        { order: 13, start: '21:30:00', finish: '22:30:00' }
      ],
      dailyWork: [],
      tasks: [],
      selectedPeriod: null,
      selectedActivity: null,
      selectedDay: null,
      totalTask: 0,
      hasCopyTask: false,
      startDateCopyTasks: null,
      finishDateCopyTasks: null,
      tasksCopied: null,
      copyAlertComponent: null
    }
  },
  methods: {
    async pasteTasksWeek () {
      this.isLoading = true
      let taks = this.mapNewTasksCopied
      console.log(taks)
      let response = await this.createTaskUsersList({ 'task_users': taks })
      console.log(response)
      await this.getTaskUsers()
    },
    checkCopyWeek () {
      let data = CopyWeeklyService.getCopiedTaskOfWeek()
      if (data.tasks) {
        this.startDateCopyTasks = data.start
        this.finishDateCopyTasks = data.finish
        this.tasksCopied = data.tasks
        this.hasCopyTask = true
        this.alertCopiedWeeks()
      }
    },
    copyWeek () {
      CopyWeeklyService.savedCopiedTaskOfWeek(this.startWeekDay, this.finishWeekDay, this.tasks)
      this.startDateCopyTasks = this.startWeekDay
      this.finishDateCopyTasks = this.finishWeekDay
      this.tasksCopied = this.tasks
      this.hasCopyTask = true
      this.alertCopiedWeeks()
    },
    alertCopiedWeeks () {
      let fromFormatedDate = this.formatedDate(this.startDateCopyTasks)
      let toFormatedDate = this.formatedDate(this.finishDateCopyTasks)
      let title = `Semana Copiada`
      let text = `${fromFormatedDate.day} al ${toFormatedDate.day} de ${toFormatedDate.month} ${toFormatedDate.year}`

      this.copyAlertComponent = Snackbar.open({
        message: `<article class="media"> <figure class="media-left"> <span class="icon is-medium"> <i class="mdi mdi-24px mdi-content-copy"></i> </figure> <div class="media-content"> <div class="content"> <p> ${title} <br> ${text} </p> </div> </div> </article>`,
        type: 'is-primary',
        position: 'is-bottom',
        actionText: 'Descartar',
        indefinite: true,
        onAction: () => {
          CopyWeeklyService.clearCopiedTasksOfWeek()
          this.hasCopyTask = false
          this.startDateCopyTasks = null
          this.finishDateCopyTasks = null
          this.tasksCopied = null
          this.$buefy.toast.open({
            message: 'Las tareas copiadas han sido descartadas',
            type: 'is-success',
            position: 'is-bottom'
          })
        }
      })
    },
    async exporToPDF (onlyRider) {
      this.isDownloadModalActive = false
      this.isDownloading = true
      this.openAlert()
      let userFilter = onlyRider ? { 'user_id': this.userId } : {}
      let fromFormatedDate = this.formatedDate(this.startWeekDay)
      let toFormatedDate = this.formatedDate(this.finishWeekDay)
      let fileName = `Calendario de Trabajo Diario ${fromFormatedDate.day} al ${toFormatedDate.day} de ${toFormatedDate.month} ${toFormatedDate.year}.pdf`

      let params = {
        from: this.fromFormated,
        to: this.toFormated,
        'include[0]': 'horse',
        'include[1]': 'taskable',
        ...userFilter
      }

      let response = await TaskUserService.exportTaskUser(params)

      if (response) {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        var fileURL = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)
        fileLink.click()
      }
      this.isDownloading = false
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    },
    periodSelected (data) {
      this.selectedPeriod = data.period
      this.selectedActivity = data.activity
      this.selectedDay = data.day
      this.isComponentModalActive = true
    },
    async generateDays () {
      let offDaysData = await this.getOffDays()
      let daysMap = this.$moment.weekdays().filter((x) => x !== 'domingo').map((day, index) => {
        let date = this.$moment(this.startWeekDay).weekday(index)
        let eventOfDays = offDaysData.filter((x) => x.date === date.format('YYYY-MM-DD'))
        let dayNumber = date.get('date')
        return {
          name: day.toUpperCase(),
          date: dayNumber,
          events: eventOfDays
        }
      })
      this.days = daysMap
      this.getTaskUsers()
    },
    async createTaskUsersList (data) {
      let response = await TaskUserService.createTaskUserList(data)
      return response
    },
    async getTaskUsers () {
      if (this.startWeekDay && this.finishWeekDay && this.userId) {
        this.isLoading = true
        let params = {
          from: this.$moment(this.startWeekDay).format('YYYY-MM-DD').toString(),
          to: this.$moment(this.finishWeekDay).format('YYYY-MM-DD').toString(),
          user_id: this.userId,
          by_day: true,
          'include[0]': 'taskable',
          'include[1]': 'horse',
          'type': 'training'
        }
        let response = await TaskUserService.getTaskUsers(params)
        this.tasks = response.data.data
        this.mapTasks()
        this.isLoading = false
      }
    },
    async getOffDays () {
      let params = {
        'include[0]': 'type',
        'year': this.$moment().year(),
        'from': this.startWeekDay,
        'to': this.finishWeekDay
      }
      let response = await OffDayService.getOffDays(params)
      return response.data.data.filter((x) => (x.type && x.type.code !== 'dominical') || !x.type)
    },
    mapTasks () {
      this.totalTask = 0
      let daysMap = this.$moment.weekdays().filter((x) => x !== 'domingo').map((day, index) => {
        let weekday = this.$moment(this.startWeekDay).weekday(index)
        let date = weekday.format('YYYY-MM-DD')
        let taskOfDay = this.tasks[date] ? this.tasks[date] : []
        this.totalTask += taskOfDay.length
        let periodsMap = this.periods.map((period, index) => {
          return taskOfDay.find((x) => x.start_at === period.start)
        })
        return {
          day: {
            name: day.toUpperCase(),
            weekday: index,
            date: date
          },
          periods: periodsMap
        }
      })
      this.dailyWork = daysMap
    },
    formatedDate (date) {
      let formatDate = this.$moment(date, 'YYYY-MM-DD')
      let dayDate = formatDate.date()
      let month = formatDate.format('MMMM')
      let year = formatDate.format('YYYY')
      return {
        day: dayDate,
        month: month,
        year: year
      }
    }
  },
  computed: {
    mapPreviusTasks () {
      let previusTasks = []
      for (const key in this.tasks) {
        if (this.tasks.hasOwnProperty(key)) {
          const tasks = this.tasks[key]
          for (let index = 0; index < tasks.length; index++) {
            const task = tasks[index]
            let mapTask = {
              'start_date': task.start_date,
              'start_at': task.start_at,
              'end_date': task.end_date,
              'end_at': task.end_at,
              'horse_id': task.horse_id,
              'training_id': task.taskable_id ? task.taskable_id : null,
              'user_id': task.user_id,
              'start_week_day': this.$moment(task.start_date, 'YYYY-MM-DD').weekday(),
              'end_week_day': this.$moment(task.end_date, 'YYYY-MM-DD').weekday()
            }
            previusTasks.push(mapTask)
          }
        }
      }
      return previusTasks
    },
    mapNewTasksCopied () {
      let previusTasks = this.mapPreviusTasks
      let newTasks = []
      for (const key in this.tasksCopied) {
        if (this.tasksCopied.hasOwnProperty(key)) {
          const tasks = this.tasksCopied[key]
          for (let index = 0; index < tasks.length; index++) {
            const task = tasks[index]
            let startWeekDay = this.$moment(task.start_date, 'YYYY-MM-DD').weekday()
            let endWeekDay = this.$moment(task.end_date, 'YYYY-MM-DD').weekday()
            let findIndex = previusTasks.findIndex((x) => x.start_week_day === startWeekDay && x.end_week_day === endWeekDay && x.start_at === task.start_at)
            if (findIndex === -1) {
              let finalStartDate = this.$moment(this.startWeekDay).weekday(startWeekDay).format('YYYY-MM-DD')
              let finalEndDate = this.$moment(this.startWeekDay).weekday(endWeekDay).format('YYYY-MM-DD')
              let mapTask = {
                'start_date': finalStartDate,
                'start_at': task.start_at,
                'end_date': finalEndDate,
                'end_at': task.end_at,
                'horse_id': task.horse_id,
                'training_id': null,
                'task_user_status_id': 1,
                'user_id': task.user_id
              }
              newTasks.push(mapTask)
            }
          }
        }
      }
      return newTasks
    },
    invalidWeekToPaste () {
      return this.$moment(this.startWeekDay).isSame(this.startDateCopyTasks) && this.$moment(this.finishWeekDay).isSame(this.finishDateCopyTasks)
    },
    subtitle () {
      if (this.userId) {
        let dataLenght = this.totalTask
        let plural = dataLenght === 1 ? '' : 's'
        return `${dataLenght} tarea${plural} registrada${plural}`
      } else {
        return `Seleccione un Jinete`
      }
    },
    fromFormated () {
      return this.$moment(this.startWeekDay).format('YYYY-MM-DD')
    },
    toFormated () {
      return this.$moment(this.finishWeekDay).format('YYYY-MM-DD')
    }
  },
  watch: {
    async startWeekDay () {
      await this.generateDays()
      this.getTaskUsers()
    },
    finishWeekDay () {
      this.getTaskUsers()
    },
    userId () {
      this.totalTask = 0
      this.getTaskUsers()
    }
  },
  destroyed () {
    if (this.copyAlertComponent) {
      this.copyAlertComponent.close()
    }
  }

}
</script>

<style scoped>
  .table *{
    text-align: center !important;
  }
  .prd-col{
    min-width: 110px !important;
  }
  .dly-tsk-col{
    min-width: 160px !important;
  }

  .break-time{
    background-color: rgba(224,224,224 ,1);
  }

  .prd-title {
    font-weight: 500;
    line-height: 20px;
  }
  .prd-time {
    font-size: 0.9rem;
    font-weight: 900;
    line-height: 20px;
  }
  table.table>tbody>tr>td{
    height: 70px !important;
    padding: 5px !important;
    vertical-align: middle !important;
  }
  td.prd-item:hover{
    background-color:white !important;
    cursor: default !important;
  }

  table.table.is-bordered td, table.table.is-bordered th{
    border-color: rgba(66,66,66 ,0.2) !important;
  }

  .block-day{
    color: #ff3860 !important;
  }

  .perdiod-block{
    background-color: rgba(255, 56, 96, 0.5) !important;
  }
</style>
